// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Unteraufgabe, UnteraufgabeDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateUnteraufgabe(): (
  aufgabeId: string,
  unteraufgabeId: string,
  requestBody: UnteraufgabeDaten
) => Promise<Unteraufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, unteraufgabeId, requestBody) =>
      (await getAPI()).unteraufgaben.updateUnteraufgabe({
        aufgabeId,
        unteraufgabeId,
        requestBody,
      }),
    [getAPI]
  );
}
